const LAST_FEW_REMAINING_BREAKPOINT = 30;

const NO_SHOWS_TEXT = "Sorry, we don’t seem to have any confirmed booking for this day. Please check back closer to the break date to see who we have confirmed to entertain you.";

export {
  LAST_FEW_REMAINING_BREAKPOINT,
  NO_SHOWS_TEXT,
};